"use client";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import CustomInput from "@/components/shared/CustomInput";
import Image from "next/image";
import search from "@/public/images/search.svg";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";
import subjectsCardImage from "@/public/images/subjectNew.svg";
import SubjectsCard from "@/components/shared/SubjectsCard";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import GENERAL, { SelectSchoolYears } from "@/redux/GENERAL";
import USER, { SelectSubjects, SelectTeachers } from "@/redux/User";
import SocialMedia from "@/components/shared/socialMedia/SocialMedia";
import defaultImage from "@/public/images/default_image.jpg";
// import { Metadata } from "next";

// export const metadata: Metadata = {
//   title: "المواد",
// };
const Page = () => {
  const dispatch = useAppDispatch();
  const [schoolYearSelected, setschoolYearSelected] = useState<any>([]);
  const [searchValue, setsearchValue] = useState("");

  const schoolYear = useAppSelector(SelectSchoolYears);

  const subjects = useAppSelector(SelectSubjects);

  useEffect(() => {
    dispatch(GENERAL.thunks.doGetSchoolYears({}));
  }, []);
  useEffect(() => {
    dispatch(
      USER.thunks.doGetSubjects({
        search: searchValue,
        school_years: schoolYearSelected,
      })
    );
  }, [searchValue, schoolYearSelected]);

  return (
    <div>
      <Header />

      <div className="container my-10 flex flex-col gap-10">
        <div className="bg-[#252F39] rounded-[20px] p-3 flex flex-col gap-5">
          <div className="flex items-center bg-[#2F3943] rounded-[5px] py-2 pl-3">
            <Formik
              initialValues={{ search: "" }}
              onSubmit={(values) => {
                setsearchValue(values.search);
              }}
            >
              {(props) => (
                <Form className="w-full flex justify-between gap-4">
                  <CustomInput
                    type="text"
                    name="search"
                    placeholder="بحث عن ماده في المنصة"
                    fullWidth={true}
                  />
                  <button type="submit">
                    <Image
                      src={search}
                      alt="search"
                    />
                  </button>
                </Form>
              )}
            </Formik>
          </div>
          <div className="flex gap-5 flex-wrap">
            {schoolYear.map((year: any, i: number) => (
              <button
                onClick={(e) => {
                  schoolYearSelected.includes(year.id)
                    ? setschoolYearSelected((prev: any) =>
                        prev.filter((item: any) => item !== year.id)
                      )
                    : setschoolYearSelected((prev: any) => [...prev, year.id]);
                }}
                className={`${
                  schoolYearSelected.includes(year.id)
                    ? "bg-primaryColor text-white"
                    : "bg-[#2F3943] text-white"
                } rounded-[5px] text-14 w-fit py-3 px-5`}
                key={i}
              >
                {year.name}
              </button>
            ))}
          </div>
        </div>

        {subjects.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 place-content-center place-items-center">
            {subjects.map((subject: any, i: number) => (
              <SubjectsCard
                key={i}
                subjectImage={subjectsCardImage || defaultImage}
                subjectName={subject.name}
                subjectId={subject.id}
                subjectDesc={subject.description}
                subjectTeachers={subject.teachers_count}
              />
            ))}
          </div>
        ) : (
          <div className="text-center text-red-400 bg-[#2F3943] rounded-[5px] py-5 px-3">
            لم يتم العثور على بيانات بناءً على الفلاتر الخاصة بك
          </div>
        )}

        {/* <Pagination page={page} setpage={setpage} numberOfPages={10} /> */}
      </div>
      <SocialMedia />
      <Footer />
    </div>
  );
};

export default Page;
